import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["panel", "buttonLabel"]
  static values = { expandedText: String, collapsedText: String }

  toggle() {
    this.panelTarget.classList.toggle("hidden")
    this.buttonLabelTarget.textContent = this.panelTarget.classList.contains("hidden") ? this.collapsedTextValue : this.expandedTextValue
  }
}
